export default class ItemTableCol {
  constructor(title, type, quantities, isRequired) {
    this.title = title;
    this.type = type;
    this.quantities = quantities;
    this.isRequired = isRequired || false;
  }
}



// WEBPACK FOOTER //
// ./src/models/ItemTableCol.js